import { getLocalStorage } from './local-storage';

import { DEFAULT_DOMESTIC_COUNTRY_CODE, SUPPORTED_COUNTRY_CODES } from './constants';

export const getDomesticCountryCode = () => {
  return getLocalStorage('domesticCountryCode') || DEFAULT_DOMESTIC_COUNTRY_CODE;
};

export const isSupportedCountryCode = (code: string) => {
  return SUPPORTED_COUNTRY_CODES.includes(code);
};
